import './services.scss';

import Swiper from 'swiper';
import { AjaxLoader } from '../../js/ajax-loader';
import { checkAndLoadFiles, createElementFromHTML, getOffset, smoothScrollTo } from '../../js/helper';

class Services {
    constructor ($element) {
        this.$services = $element;
        this.$servicesTarget = this.$services.querySelector('[data-services="target"]');
        this.$countrySelect = null;
        this.countrySwitch = null;

        this.topicSlider = [];
        this.addressSlider = [];
        this.$topics = null;
        this.$addresses = null;
        this.$topicsSliderContainer = null;
        this.topicSliderActive = false;
        this.addressSliderActive = false;
        this.$serviceCenterSelectionButtons = null;
        this.animationsSpeed = 500;
        this.wait = false;
        this.selections = {
            country: null,
            subjectType: null,
            serviceCenterId: null
        };

        this.$stepper = this.$services.querySelector('[data-stepper="root"]');
        this.$stepperBack = this.$services.querySelector('[data-stepper-back]');
        this.stepBackTimeout = null;
        this.$stepperChoices = this.$services.querySelector('[data-stepper="choices"]');
        this.$stepperArr = [];
        this.lastID = 0;
        this.baseURL = this.$stepper.dataset.stepperBaseUrl;
        this.lastURL = this.baseURL;
        this.popStateTimeout = null;
        this.loadServiceTimeout = null;
    }

    initialize () {
        this.setHistory({
            state: 'ajax',
            url: this.baseURL,
            stepperArr: []
        });

        this.initContents();
        this.setEvents();
        this.checkParamsFromURL();
    }

    initContents () {
        this.$countrySelect = this.$services.querySelector('[data-services="country"]');
        this.$country = this.$services.querySelector('[data-services-country="root"]');
        this.$countrySubmit = this.$services.querySelector('[data-services-country-submit]');
        this.topicSlider = [];
        this.addressSlider = [];
        this.$topics = this.$services.querySelector('[data-services-topics="root"]');
        this.$contactTopics = this.$services.querySelector('[data-services-contact-topics="root"]');
        this.$contactTopicsCloses = this.$contactTopics?.querySelectorAll('[data-services-contact-topics="close"]');
        this.$topicsSliderContainer = this.$services.querySelectorAll('[data-services-topics="slider"]');
        this.$addressSliderContainer = this.$services.querySelectorAll('[data-services-addresses="slider"]');
        this.$topicsOpener = this.$services.querySelectorAll('[data-services-topic-index]');
        this.$targetContainer = this.$services.querySelector('[data-services-topic-targets]');
        this.$servicesTarget = this.$services.querySelector('[data-services="target"]');
        this.topicSliderActive = false;
        this.addressSliderActive = false;
        this.$serviceCenterSelectionButtons = this.$services.querySelectorAll('[data-services-selection-url]');
        this.countrySelected = false;
        this.countryPreselected = false;

        if (this.$countrySelect) {
            this.initCountry();
        }

        if (this.$topics || this.$addressSliderContainer) {
            if (this.$topics) {
                this.initTopics();
            }

            this.checkSizes();
        }

        if (this.$serviceCenterSelectionButtons.length > 0) {
            this.setServiceSelectionEvents();
        }

        if (this.$contactTopics) {
            this.initTopicOpener();
        }
    }

    checkParamsFromURL () {
        const URLParms = window.location.search;
        const cookieConsentMarketing = window.CONSENT_MARKETING_TRUE;
        if (URLParms && cookieConsentMarketing === 'true') {
            this.setOptionsByURLParms();
        }
    }

    setOptionsByURLParms () {
        const params = new URLSearchParams(document.location.search);
        const subjectType = params.get('subjectType');
        this.countryPreselected = this.$countrySelect.dataset.countryPreselcted;

        const checkIfCountryIsSelected = () => {
            if (this.$countrySelect.value) {
                this.activateTopicByType(subjectType);
            }
        };

        if (this.countryPreselected === 'true') {
            setTimeout(() => {
                this.$countrySelect.onchange = () => {
                    checkIfCountryIsSelected();
                };
            }, 200); // wait 200ms to prevent firing the event if preselected
        } else {
            this.$countrySelect.onchange = () => {
                checkIfCountryIsSelected();
            };
        }

        this.$countrySubmit.onclick = () => {
            checkIfCountryIsSelected();
        };
    }

    activateTopicByType (subjectType) {
        this.countrySelected = true;

        if (this.countrySelected) {
            this.$services.classList.add('services__topics--hide-topics');
            const intervalId = setInterval(() => {
                if (this.$topics && subjectType) {
                    const $selectedTopic = this.$topics.querySelector(`[data-services-subject-type="${subjectType}"]`);
                    if ($selectedTopic) {
                        $selectedTopic.click();
                        clearInterval(intervalId);

                        setTimeout(() => {
                            this.$services.classList.remove('services__topics--hide-topics');
                        }, 1000);
                    }
                }
            }, 100);

            // Clear the interval after a certain amount of time to prevent infinite loop - show topics
            setTimeout(() => {
                clearInterval(intervalId);
                this.$services.classList.remove('services__topics--hide-topics');
            }, 10000);
        }
    }

    setEvents () {
        this.$stepper.addEventListener('click', (e) => {
            if ((e.target.getAttribute('data-stepper-back') != null || e.target.getAttribute('data-stepper-direct') != null)) {
                clearTimeout(this.stepBackTimeout);
                this.$services.classList.add('has--action');

                this.stepBackTimeout = setTimeout(() => {
                    if (e.target.getAttribute('data-stepper-back') !== null) {
                        console.info('Step back -> now');
                        window.history.back();
                    }

                    if (e.target.getAttribute('data-stepper-direct')) {
                        const url = e.target.getAttribute('data-stepper-direct');
                        const id = parseInt(e.target.getAttribute('data-stepper-id'));
                        const historyData = {};

                        smoothScrollTo(0, getOffset(this.$services).top, 100);

                        const formData = new FormData();
                        this.$stepper.appendChild(createElementFromHTML(window.OPTIONS.loader));

                        if (this.selections.country) {
                            formData.append('country', this.selections.country);
                            historyData.country = this.selections.country;
                        }

                        if (this.selections.subjectType) {
                            formData.append('subjectType', this.selections.subjectType);
                            historyData.subjectType = this.selections.subjectType;
                        }

                        historyData.type = 'ajax';
                        historyData.url = url;

                        this.result = new AjaxLoader(url, {
                            requestMethod: 'POST',
                            requestData: formData,
                            onSuccess: (resultText) => {
                                const results = JSON.parse(resultText);
                                this.setResults(results.html);
                                historyData.stepperArr = this.$stepperArr;
                                this.setHistory(historyData);

                                setTimeout(() => {
                                    this.$services.classList.remove('has--action');
                                }, 200);
                            },
                            onError: (error) => {
                                console.warn(error);
                            }
                        });

                        this.changeStepper(id);
                        this.lastURL = url;
                    }
                }, 250);
            }
        });

        window.onpopstate = (e) => {
            clearTimeout(this.popStateTimeout);
            this.$services.classList.add('has--action');

            if (e.state !== null) {
                this.popStateTimeout = setTimeout(() => {
                    this.getHistoryData(history.state, (formData, url) => {
                        this.result = new AjaxLoader(url, {
                            requestMethod: 'POST',
                            requestData: formData,
                            onSuccess: (resultText) => {
                                const results = JSON.parse(resultText);
                                this.setResults(results.html);
                                this.popStateCounter = 0;

                                setTimeout(() => {
                                    this.$services.classList.remove('has--action');
                                }, 200);
                            },
                            onError: (error) => {
                                console.warn(error);
                            }
                        });

                        this.setFullStepper(e.state.stepperArr);
                        this.lastURL = url;
                    });
                }, 200);
            }
        };
    }

    setServiceSelectionEvents () {
        this.$serviceCenterSelectionButtons.forEach(($selection) => {
            $selection.addEventListener('click', () => {
                clearTimeout(this.loadServiceTimeout);
                this.$services.classList.add('has--action');

                this.loadServiceTimeout = setTimeout(() => {
                    const url = $selection.dataset.servicesSelectionUrl;
                    this.selections.serviceCenterId = $selection.dataset.servicesSelectionId;
                    this.$servicesTarget.firstElementChild.appendChild(createElementFromHTML(window.OPTIONS.loader));

                    this.loadData(url, 'Service Center', {
                        country: this.selections.country,
                        subjectType: this.selections.subjectType,
                        serviceCenterId: this.selections.serviceCenterId
                    });
                }, 200);
            });
        });
    }

    loadData (url, stepperLabel, options) {
        const formData = new FormData();
        const historyData = {};

        if (typeof options !== 'undefined') {
            if (typeof options.country !== 'undefined') {
                formData.append('country', options.country);
                historyData.country = options.country;
                this.selections.country = options.country;
            }

            if (typeof options.subjectType !== 'undefined') {
                formData.append('subjectType', options.subjectType);
                historyData.subjectType = options.subjectType;
                this.selections.subjectType = options.subjectType;
            }

            if (typeof options.serviceCenterId !== 'undefined') {
                formData.append('serviceCenterId', options.serviceCenterId);
                historyData.serviceCenterId = options.serviceCenterId;
                this.selections.serviceCenterId = options.serviceCenterId;
            }

            historyData.type = 'ajax';
            historyData.url = url;
        }

        smoothScrollTo(0, getOffset(this.$services).top, 100);

        this.result = new AjaxLoader(url, {
            requestMethod: 'POST',
            requestData: formData,
            onSuccess: (resultText) => {
                const results = JSON.parse(resultText);
                this.setResults(results.html);

                if (typeof stepperLabel !== 'undefined' && typeof options !== 'undefined') {
                    this.setStepper(url, stepperLabel, false);
                    historyData.stepperArr = this.$stepperArr;
                    this.setHistory(historyData);
                }

                setTimeout(() => {
                    this.$services.classList.remove('has--action');
                }, 200);
            },
            onError: (error) => {
                console.warn(error);
            }
        });
    }

    initCountry () {
        import('../../components/form/select-box').then(({ SelectBox }) => {
            this.countrySwitch = new SelectBox(this.$countrySelect, {
                width: 'auto'
            });

            this.$countrySelect.addEventListener('change', () => {
                this.loadTopics();
            });

            const $errors = this.$country.querySelector('[data-services-error]');
            const $countrySubmit = this.$country.querySelector('button[type="button"].cta');

            if ($countrySubmit) {
                $countrySubmit.addEventListener('click', (e) => {
                    if (this.$countrySelect.value === '') {
                        if ($errors) {
                            $errors.classList.remove('is--hidden');

                            setTimeout(() => {
                                $errors.classList.add('is--hidden');
                            }, 5000);
                        }

                        e.preventDefault();
                    } else {
                        if ($errors) {
                            $errors.classList.add('is--hidden');
                        }

                        this.loadTopics();
                    }
                });
            }
        });
    }

    loadTopics () {
        const url = this.$countrySelect.dataset.servicesUrl;
        const stepperLabel = this.$countrySelect.querySelector('[selected]').innerText;
        const country = this.$countrySelect.value;

        this.$country.appendChild(createElementFromHTML(window.OPTIONS.loader));

        this.loadData(url, stepperLabel, {
            country: country
        });
    }

    initTopics () {
        const $topics = this.$services.querySelectorAll('[data-services-topics="slide"]');

        $topics.forEach(($topic) => {
            $topic.addEventListener('click', () => {
                if ($topic.dataset.servicesUrl) {
                    this.loadFormular($topic);
                } else {
                    if ($topic.dataset.servicesExternal !== '') {
                        window.open($topic.dataset.servicesExternal, '_blank');
                    }
                }
            });
        });
    }

    loadFormular ($topic) {
        const url = $topic.dataset.servicesUrl;
        const stepperLabel = $topic.dataset.servicesStepperLabel;
        const subjectType = $topic.dataset.servicesSubjectType;
        const country = this.selections.country;
        this.$topics.appendChild(createElementFromHTML(window.OPTIONS.loader));

        this.loadData(url, stepperLabel, {
            country: country,
            subjectType: subjectType
        });
    }

    initTopicSlider () {
        this.topicSliderActive = true;

        this.$topicsSliderContainer.forEach((slider, index) => {
            this.$topicSliderControls = slider.parentElement.querySelector('[data-services-topics="controls"]');
            this.prevButton = null;
            this.nextButton = null;

            if (this.$topicSliderControls) {
                this.prevButton = this.$topicSliderControls.querySelector('[data-services-topics="prev"]');
                this.nextButton = this.$topicSliderControls.querySelector('[data-services-topics="next"]');
            }

            this.topicSlider[index] = new Swiper(slider, {
                slidesPerView: 'auto',
                spaceBetween: 16,
                speed: 500,
                autoHeight: false,
                navigation: {
                    prevEl: this.prevButton,
                    nextEl: this.nextButton
                },
                pagination: {
                    el: slider.nextElementSibling.querySelector('.swiper-pagination'),
                    type: 'progressbar'
                }
            });
        });
    }

    initAddressSlider () {
        this.addressSliderActive = true;

        this.$addressSliderContainer.forEach((slider, index) => {
            if (slider.querySelectorAll('[data-services-addresses="slide"]').length > 1) {
                this.addressSlider[index] = new Swiper(slider, {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    speed: 500,
                    autoHeight: true,
                    observer: true,
                    threshold: 5,
                    pagination: {
                        el: slider.nextElementSibling.querySelector('.swiper-pagination'),
                        type: 'progressbar'
                    }
                });

                const $accordionInputs = slider.querySelectorAll('input.checkbox__hidden');

                if ($accordionInputs.length > 0) {
                    $accordionInputs.forEach((input) => {
                        input.addEventListener('change', () => {
                            if (window.innerWidth < 1024) {
                                for (let i = 0; i < 5; i++) {
                                    setTimeout(() => {
                                        this.addressSlider[index].update();
                                    }, i * 50);
                                }
                            }
                        });
                    });
                }
            }
        });
    }

    setResults (results) {
        const $origin = this.$servicesTarget.firstElementChild;
        const $results = createElementFromHTML(results);
        const $loader = this.$stepper.querySelector('.loading');

        if ($results.length > 1) {
            $results.forEach((element) => {
                this.$servicesTarget.appendChild(element);
            });
        } else {
            this.$servicesTarget.appendChild($results);
        }

        $origin.style.height = $origin.scrollHeight + 'px';
        $origin.classList.add('has--height');

        setTimeout(() => {
            $origin.style.height = '0px';

            if ($loader) {
                $loader.remove();
            }
        }, 50);

        setTimeout(() => {
            $origin.remove();

            $results.style.height = $results.scrollHeight + 'px';
            $results.style.filter = 'blur(0)';

            setTimeout(() => {
                $results.style.filter = '';
                $results.classList.remove('has--height');
                $results.style.height = '';
                this.initContents();
            }, this.animationsSpeed);
        }, this.animationsSpeed);

        checkAndLoadFiles(this.$servicesTarget).then((data) => {
            window.dispatchEvent(new CustomEvent('content.loaded', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    $context: this.$servicesTarget
                }
            }));
        });
    }

    destroyTopicSlider () {
        for (let i = 0; i < this.topicSlider.length; i++) {
            if (this.topicSlider[i] !== null) {
                this.topicSlider[i].destroy(true, true);
                this.topicSlider[i] = null;
                this.topicSliderActive = false;
            }
        }
    }

    destroyAddressSlider () {
        for (let i = 0; i < this.addressSlider.length; i++) {
            if (this.addressSlider[i] !== null) {
                this.addressSlider[i].destroy(true, true);
                this.addressSlider[i] = null;
                this.addressSliderActive = false;
            }
        }
    }

    initTopicOpener () {
        this.$topicsOpener.forEach(($topic) => {
            $topic.addEventListener('click', () => {
                if (!this.wait) {
                    if (typeof $topic.dataset.servicesExternal === 'undefined') {
                        this.openTopic($topic);
                    } else {
                        if ($topic.dataset.servicesExternal !== '') {
                            window.open($topic.dataset.servicesExternal, '_blank');
                        }
                    }
                }
            });
        });

        this.$contactTopicsCloses.forEach(($closeButton) => {
            $closeButton.addEventListener('click', () => {
                this.closeActiveTopic();
                smoothScrollTo(0, getOffset(this.$contactTopics).top, 100);
            });
        });
    }

    openTopic (topic) {
        const $targetTopic = this.$targetContainer.querySelector('[data-services-topic-target="' + topic.dataset.servicesTopicIndex + '"]');

        if ($targetTopic) {
            if (!topic.classList.contains('is--active')) {
                this.closeActiveTopic(() => {
                    $targetTopic.style.height = $targetTopic.scrollHeight + 'px';
                    topic.classList.add('is--active');

                    smoothScrollTo(0, getOffset(this.$targetContainer).top, 100);

                    setTimeout(() => {
                        $targetTopic.style.height = 'auto';
                        this.wait = false;
                    }, this.animationsSpeed);
                });
            } else {
                this.closeActiveTopic();
            }
        }
    }

    closeActiveTopic (callback) {
        const $activeTopic = this.$services.querySelector('[data-services-topic-index].is--active');

        if ($activeTopic) {
            const $activeTopicTarget = this.$targetContainer.querySelector('[data-services-topic-target="' + $activeTopic.dataset.servicesTopicIndex + '"]');

            $activeTopicTarget.style.height = $activeTopicTarget.scrollHeight + 'px';
            $activeTopic.classList.remove('is--active');
            this.wait = true;

            setTimeout(() => {
                $activeTopicTarget.style.height = '0px';
            }, 50);

            setTimeout(() => {
                this.wait = false;

                if (typeof callback === 'function') {
                    callback();
                }
            }, this.animationsSpeed.speed + 50);
        } else {
            if (typeof callback === 'function') {
                callback();
            }
        }
    }

    checkSizes () {
        if (!window.mediaMatch[768].matches) {
            this.initTopicSlider();
        }

        if (!window.mediaMatch[1024].matches) {
            if (this.$addressSliderContainer) {
                this.initAddressSlider();
            }
        }

        window.mediaMatch[768].addEventListener('change', (match) => {
            if (!match.matches && !this.topicSliderActive) {
                this.initTopicSlider();
            }

            if (match.matches) {
                if (this.topicSliderActive) {
                    this.destroyTopicSlider();
                }
            }
        });

        window.mediaMatch[1024].addEventListener('change', (match) => {
            if (!match.matches && !this.addressSliderActive) {
                this.initAddressSlider();
            }

            if (match.matches) {
                if (this.addressSliderActive) {
                    this.destroyAddressSlider();
                }
            }
        });
    }

    setStepper (url, label, setDirect) {
        let urlToSet = this.lastURL;

        if (this.$stepper.classList.contains('is--hidden')) {
            this.showStepper();
        }

        if (setDirect) {
            urlToSet = url;
        }

        this.$stepperArr.push({
            id: this.lastID,
            url: urlToSet,
            label: label
        });

        const entry = '<li class="stepper__choices-item" data-stepper-direct="' + urlToSet + '" data-stepper-id="' + this.lastID + '"><span>' + label + '</span></li>';
        this.$stepperChoices.appendChild(createElementFromHTML(entry));
        this.lastID++;
        this.lastURL = url;
    }

    setFullStepper (stepperArr) {
        this.$stepperChoices.innerHTML = '';
        this.$stepperArr = [];
        this.lastID = 0;

        if (stepperArr.length === 0) {
            this.hideStepper();
        } else {
            stepperArr.forEach((step, index) => {
                this.setStepper(step.url, step.label, true);
            });
        }
    }

    changeStepper (id) {
        id = parseInt(id);

        this.$stepperArr.forEach((entry) => {
            if (entry.id >= id) {
                setTimeout(() => {
                    this.$stepperChoices.querySelector('[data-stepper-id="' + entry.id + '"]').remove();
                }, this.animationsSpeed);
            }
        });

        if (id === 0) {
            this.hideStepper();
            this.$stepperArr = [];
            this.lastURL = this.baseURL;
        } else {
            this.$stepperArr.splice(id);
        }
        this.lastID = id;
    }

    hideStepper () {
        setTimeout(() => {
            this.$stepper.classList.add('is--hidden');
        }, this.animationsSpeed);
    }

    showStepper () {
        setTimeout(() => {
            this.$stepper.classList.remove('is--hidden');
        }, this.animationsSpeed);
    }

    setHistory (historyData) {
        history.pushState(historyData, '', window.location.href);
    }

    getHistoryData (data, callback) {
        const formData = new FormData();

        for (const key in data) {
            formData.append(key, data[key]);
        }

        if (typeof callback === 'function') {
            callback(formData, data.url);
        }
    }
}

export { Services };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $services = $context.querySelector('[data-services="root"]');

        if ($services) {
            const $Services = new Services($services);
            $Services.initialize();
        }
    }
});
